import React, { Component, createRef } from "react";
import Dropzone from "react-dropzone";

import { Button, Card, CardBody, Col, Container, Label, Row } from "reactstrap";

import { Link } from "react-router-dom";
import { Formik, Field, Form, ErrorMessage } from "formik";
import * as Yup from "yup";

//Import Breadcrumb
import Breadcrumbs from "../../components/Common/Breadcrumb";
import { getOrganizatioanApi, updateOrganisation ,baseUrl} from "api";
import { withTranslation } from "react-i18next";

class OrganizationDetail extends Component {
  constructor(props) {
    super(props);
    this.state = {
      validation: "",
      organizationList: [],
      selectedFiles: [],
    };
    this.filesharhe_ref = createRef();
    this.handleSubmit = this.handleSubmit.bind(this);
    this.onChangeValidation = this.onChangeValidation.bind(this);
    this.handleAcceptedFiles = this.handleAcceptedFiles.bind(this);
  }

  handleAcceptedFiles = files => {
    files.map(file =>
      Object.assign(file, {
        preview: URL.createObjectURL(file),
        formattedSize: this.formatBytes(file.size),
      })
    );

    this.setState({ selectedFiles: files });
  };

  formatBytes = (bytes, decimals = 2) => {
    if (bytes === 0) return "0 Bytes";
    const k = 1024;
    const dm = decimals < 0 ? 0 : decimals;
    const sizes = ["Bytes", "KB", "MB", "GB", "TB", "PB", "EB", "ZB", "YB"];

    const i = Math.floor(Math.log(bytes) / Math.log(k));
    return parseFloat((bytes / Math.pow(k, i)).toFixed(dm)) + " " + sizes[i];
  };

  async componentDidMount() {
    let data = await getOrganizatioanApi();
    console.log(data.data);

    if(data.data.organizations && data.data.organizations.length )
    this.setState(
      {
        organizationList: data.data.organizations[0],
        selectedFiles:
          typeof data.data.organizations[0].logo == "string"
            ? [
                {
                  preview: `${baseUrl}/uploads/${data.data.organizations[0].logo}`,
                },
              ]
            : [],
      },
    );
  }

  async handleSubmit(e, values) {
    e.preventDefault();
    delete values.createdAt;
    delete values.updatedAt;
    let formdata = new FormData();
    Object.keys(values).forEach(x => formdata.append(x, values[x]));
    formdata.delete("logo")
    if(this.state.selectedFiles.length > 0 && "formattedSize" in this.state.selectedFiles[0] )
      formdata.append("logo", this.state.selectedFiles[0]);
    const data = updateOrganisation(formdata.get("id"), formdata);
  }

  //for change tooltip display propery
  onChangeValidation(fieldName, value) {
    const modifiedV = { ...this.state.validation };
    if (value !== "") {
      modifiedV[fieldName] = true;
    } else {
      modifiedV[fieldName] = false;
    }
    this.setState({ validation: modifiedV });
  }

  render() {
    //meta title
    document.title = "Manage organization";
    const { validation } = this.state;
    return (
      <React.Fragment>
        <div className="page-content">
          <Container fluid={true}>
            <Breadcrumbs breadcrumbItem={this.props.t("Manage Organization")} />
            <Row>
              <Col xl="12">
                <Card>
                  <CardBody>
                    <Formik
                      enableReinitialize={true}
                      initialValues={
                        this.state.organizationList
                          ? this.state.organizationList
                          : {
                              id: "",
                              name: "",
                              gstNo: "",
                              panNo: "",
                              cinLlpIn: "",
                              addressLine1: "",
                              addressLine2: "",
                              city: "",
                              state: "",
                              zipCode: "",
                              mobileNo1: "",
                              mobileNo2: "",
                              email: "",
                              shortName: "",
                              since: "",
                              tdsRate: "",
                              tagLine: "",
                              adminNotes: "",
                              status: true,
                            }
                      }
                      validationSchema={Yup.object().shape({
                        logo: Yup.string()
                          .nullable()
                          .notRequired()
                          .test(
                            "FILE_SIZE",
                            "Uploaded file is too big.",
                            value => !value || (value && value.size <= 500000)
                          )
                          .test(
                            "FILE_FORMAT",
                            "Uploaded file has unsupported format.",
                            value =>
                              !value ||
                              (value &&
                                ["jpg", "jpeg", "png"].includes(value.type))
                          ),
                        id: Yup.string().required(
                          "Please Enter Your Party Code"
                        ),
                        name: Yup.string().min(1).max(255).required(
                          "Please Enter Your {this.props.t('Party Name')}"
                        ),
                        gstNo: Yup.string().min(0).max(255).required(
                          "Please Enter Your gstNo number"
                        ),
                        panNo: Yup.string().min(1).max(255).required(
                          "Please Enter Your panNo number"
                        ),
                        tdsRate: Yup.string().min(1).max(255).required(
                          "Please Enter Your panNo number"
                        ),
                        cinLlpIn: Yup.string().min(1).max(255).required(
                          "Please Enter Your CIN/LLP number"
                        ),
                        addressLine1: Yup.string().min(1).max(255).required(
                          "Please Enter Your Address"
                        ),
                        addressLine2: Yup.string().min(1).max(255).required(
                          "Please Enter Your Address"
                        ),
                        city: Yup.string().min(1).max(255).required("Please Enter Your city"),
                        state: Yup.string().min(1).max(255).required("Please Enter Your state"),
                        zipCode: Yup.number()
                          .min(1)
                          .max(999999)
                          .required("Please Enter zIPCode code"),
                        mobileNo1: Yup.number()
                          .min(1111111111)
                          .max(9999999999)
                          .required("Please Enter Your Mobile Number"),
                        mobileNo2: Yup.number()
                          .min(1111111111)
                          .max(9999999999)
                          .required("Please Enter Your Mobile Number"),
                        email: Yup.string().min(1).max(255).required("Please Enter Your email"),
                        shortName: Yup.string().min(1).max(255).required(
                          "Please Enter Your Short Name"
                        ),
                        since: Yup.number()
                          .min(1111)
                          .max(9999)
                          .required("This value is required"),
                        tagLine: Yup.string().min(1).max(255).required(
                          "This value is required"
                        ),
                        adminNotes: Yup.string().min(1).max(255).required(
                          "This value is required"
                        ),
                      })}
                      onSubmit={values => {}}
                    >
                      {({ errors, status, touched, values, submitCount }) => (
                        <Form className="needs-validation">
                          <Row>
                            <h4 className="pb-3 text-black fw-bold">
                              <div className="d-flex flex-row mb-4 justify-content-between">
                                <div>
                                  <h4 className="text-black fw-bold mb-4">
                                    {this.props.t("Organization details")}
                                  </h4>
                                </div>
                                <div>
                                  <div className="d-inline-block me-3 fs-5 fw-bold">
                                    Active
                                  </div>
                                  <div className="form-check form-switch d-inline-block">
                                    <Field
                                      className="form-check-input fs-5"
                                      type="checkbox"
                                      name="status"
                                    />
                                    <label className="form-check-label pt-4"></label>
                                  </div>
                                </div>
                              </div>
                            </h4>
                            <div className="mb-3 row">
                              <label
                                htmlFor="example-number-input"
                                className="col-md-2 col-form-label"
                              >
                                <h5 className="text-secondary fw-bold">
                                  {this.props.t('Company Logo')}
                                </h5>
                              </label>

                              <div className="col-md-10">
                                <Dropzone
                                multiple
                                  onDrop={acceptedFiles => {
                                    this.handleAcceptedFiles(acceptedFiles);
                                  }}
                                >
                                  {({ getRootProps, getInputProps }) => (
                                    <div
                                      className="dropzone"
                                    >
                                      <div
                                        className="dz-message needsclick"
                                        {...getRootProps()}
                                      >
                                        <input {...getInputProps()} />
                                        <div className="mb-3">
                                          <i className="display-4 text-muted bx bxs-cloud-upload" />
                                        </div>
                                        <h4>
                                          Drop logo here or click to upload.
                                        </h4>
                                      </div>
                                    </div>
                                  )}
                                </Dropzone>
                                {/* {this.state.selectedFiles.length < 1 &&
                                submitCount > 0 ? (
                                  <p className="text-danger">
                                    Please Upload Photo
                                  </p>
                                ) : (
                                  <></>
                                )} */}
                                <div
                                  className="dropzone-previews mt-3"
                                  id="file-previews"
                                >
                                  {this.state.selectedFiles.map((f, i) => {
                                    return (
                                      <Card
                                        className="mt-1 mb-0 shadow-none border dz-processing dz-image-preview dz-success dz-complete"
                                        key={i + "-file"}
                                      >
                                        <div className="p-2">
                                          <Row className="align-items-center">
                                          <Col className="col-auto thumb">
                                                <img
                                                  data-dz-thumbnail=""
                                                  height="80"
                                                  className="avatar-sm rounded bg-light thumbInner"
                                                  alt={f.name}
                                                  src={f.preview}
                                                />
                                                <button
                                                  type="button"
                                                  onClick={() => {
                                                    this.setState(
                                                      this.state.selectedFiles.pop()
                                                    );

                                                    this.setState([
                                                      ...this.state.selectedFiles,
                                                    ]);
                                                  }}
                                                  className="bg-transparent border-0"
                                                >
                                                  {" "}
                                                  <div className="middle">
                                                    <i className="fa-solid fa-circle-xmark fs-1 bg-white text-secondary"></i>
                                                  </div>
                                                </button>
                                              </Col>
                                            <Col>
                                              <Link
                                                to="#"
                                                className="text-muted font-weight-bold"
                                              >
                                                {f.name}
                                              </Link>
                                              <p className="mb-0">
                                                <strong>
                                                  {f.formattedSize}
                                                </strong>
                                              </p>
                                            </Col>
                                          </Row>
                                        </div>
                                      </Card>
                                    );
                                  })}
                                </div>
                              </div>
                            </div>
                            <div className="mb-3 row">
                              <Label
                                htmlFor="id"
                                className="col-md-2 col-form-label"
                              >
                                <h5 className="text-secondary fw-bold">
                                  {this.props.t('Company Code')}
                                </h5>
                              </Label>
                              <div className="col-md-10">
                                <Field
                                  className={
                                    "form-control fs-5 text-uppercase" +
                                    (errors.id && touched.id
                                      ? " is-invalid"
                                      : "")
                                  }
                                  disabled
                                  type="text"
                                  name="id"
                                  placeholder="xxx0125fgtr"
                                />
                                <ErrorMessage
                                  name="id"
                                  component="div"
                                  className="invalid-feedback"
                                />
                              </div>
                            </div>
                            <div className="mb-3 row">
                              <Label
                                htmlFor="name"
                                className="col-md-2 col-form-label"
                              >
                                <h5 className="text-secondary fw-bold">{this.props.t('Company Name')}</h5>
                              </Label>
                              <div className="col-md-10">
                                <Field
                                  className={
                                    "form-control fs-5" +
                                    (errors.name && touched.name
                                      ? " is-invalid"
                                      : "")
                                  }
                                  type="text"
                                  name="name"
                                  placeholder="XYZ Diamond"
                                />
                                <ErrorMessage
                                  name="name"
                                  component="div"
                                  className="invalid-feedback"
                                />
                              </div>
                            </div>
                            <div className="mb-3 row">
                              <Label
                                htmlFor="gstNo"
                                className="col-md-2 col-form-label"
                              >
                                <h5 className="text-secondary fw-bold">
                                  {this.props.t("GST No.")}
                                </h5>
                              </Label>
                              <div className="col-md-10">
                                <Field
                                  className={
                                    "form-control fs-5" +
                                    (errors.gstNo && touched.gstNo
                                      ? " is-invalid"
                                      : "")
                                  }
                                  type="text"
                                  name="gstNo"
                                  placeholder="04AABCU9603R1ZV"
                                />
                                <ErrorMessage
                                  name="gstNo"
                                  component="div"
                                  className="invalid-feedback"
                                />
                              </div>
                            </div>
                            <div className="mb-3 row">
                              <Label
                                htmlFor="panNo"
                                className="col-md-2 col-form-label"
                              >
                                <h5 className="text-secondary fw-bold">
                                  {this.props.t("pan No.")}
                                </h5>
                              </Label>
                              <div className="col-md-10">
                                <Field
                                  className={
                                    "form-control fs-5 text-uppercase" +
                                    (errors.panNo && touched.panNo
                                      ? " is-invalid"
                                      : "")
                                  }
                                  type="text"
                                  name="panNo"
                                  placeholder="AAECC6548C"
                                />
                                <ErrorMessage
                                  name="panNo"
                                  component="div"
                                  className="invalid-feedback"
                                />
                              </div>
                            </div>
                            <div className="mb-3 row">
                              <Label
                                htmlFor="tdsRate"
                                className="col-md-2 col-form-label"
                              >
                                <h5 className="text-secondary fw-bold">
                                  {this.props.t("TDS Rate")}
                                </h5>
                              </Label>
                              <div className="col-md-10">
                                <Field
                                  className={
                                    "form-control fs-5 text-uppercase" +
                                    (errors.tdsRate && touched.tdsRate
                                      ? " is-invalid"
                                      : "")
                                  }
                                  type="text"
                                  name="tdsRate"
                                  placeholder="AAECC6548C"
                                />
                                <ErrorMessage
                                  name="tdsRate"
                                  component="div"
                                  className="invalid-feedback"
                                />
                              </div>
                            </div>
                            <div className="mb-3 row">
                              <Label
                                htmlFor="cinLlpIn"
                                className="col-md-2 col-form-label"
                              >
                                <h5 className="text-secondary fw-bold">
                                  CIN / LLP IN
                                </h5>
                              </Label>
                              <div className="col-md-10">
                                <Field
                                  className={
                                    "form-control fs-5" +
                                    (errors.cinLlpIn && touched.cinLlpIn
                                      ? " is-invalid"
                                      : "")
                                  }
                                  type="text"
                                  name="cinLlpIn"
                                  placeholder="L01631KA2010PTC096843"
                                />
                                <ErrorMessage
                                  name="cinLlpIn"
                                  component="div"
                                  className="invalid-feedback"
                                />
                              </div>
                            </div>
                            <div className="mb-3 row">
                              <Label
                                htmlFor="addressLine1"
                                className="col-md-2 col-form-label"
                              >
                                <h5 className="text-secondary fw-bold">{this.props.t('Address line 1')}</h5>
                              </Label>
                              <div className="col-md-10">
                                <Field
                                  className={
                                    "form-control fs-5" +
                                    (errors.addressLine1 && touched.addressLine1
                                      ? " is-invalid"
                                      : "")
                                  }
                                  type="text"
                                  name="addressLine1"
                                  placeholder="1901 Thornridge Cir. Shiloh, Hawaii 81063"
                                />
                                <ErrorMessage
                                  name="addressLine1"
                                  component="div"
                                  className="invalid-feedback"
                                />
                              </div>
                            </div>
                            <div className="mb-3 row">
                              <Label
                                htmlFor="addressLine2"
                                className="col-md-2 col-form-label"
                              >
                                <h5 className="text-secondary fw-bold">{this.props.t('Address line 2')}</h5>
                              </Label>
                              <div className="col-md-10">
                                <Field
                                  className={
                                    "form-control fs-5" +
                                    (errors.addressLine2 && touched.addressLine2
                                      ? " is-invalid"
                                      : "")
                                  }
                                  type="text"
                                  name="addressLine2"
                                  placeholder="1901 Thornridge Cir. Shiloh, Hawaii 81063"
                                />
                                <ErrorMessage
                                  name="addressLine2"
                                  component="div"
                                  className="invalid-feedback"
                                />
                              </div>
                            </div>
                            <div className="mb-3 row">
                              <Label
                                htmlFor="city"
                                className="col-md-2 col-form-label"
                              >
                                <h5 className="text-secondary fw-bold">{this.props.t('City')}</h5>
                              </Label>
                              <div className="col-md-10">
                                <Field
                                  className={
                                    "form-control fs-5" +
                                    (errors.city && touched.city
                                      ? " is-invalid"
                                      : "")
                                  }
                                  type="text"
                                  name="city"
                                  placeholder="City"
                                />
                                <ErrorMessage
                                  name="city"
                                  component="div"
                                  className="invalid-feedback"
                                />
                              </div>
                            </div>
                            <div className="mb-3 row">
                              <Label
                                htmlFor="state"
                                className="col-md-2 col-form-label"
                              >
                                <h5 className="text-secondary fw-bold">{this.props.t('State')}</h5>
                              </Label>
                              <div className="col-md-10">
                                <Field
                                  className={
                                    "form-control form-select fs-5" +
                                    (errors.state && touched.state
                                      ? " is-invalid"
                                      : "")
                                  }
                                  name="state"
                                  as="select"
                                >
                                  <option value="" disabled>select</option>
                                  <option value="1">Gujarat</option>
                                  <option value="2">Maharashtra</option>
                                  <option value="3">Tamil Nadu</option>
                                  <option value="4">Uttar Pradesh</option>
                                  <option value="5">West Bengal</option>
                                  <option value="6">Karnataka</option>
                                  <option value="7">Rajasthan</option>
                                  <option value="8">Andhra Pradesh</option>
                                  <option value="9">Madhya Pradesh</option>
                                </Field>
                                <ErrorMessage
                                  name="state"
                                  component="div"
                                  className="invalid-feedback"
                                />
                              </div>
                            </div>
                            <div className="mb-3 row">
                              <Label
                                htmlFor="zipCode"
                                className="col-md-2 col-form-label"
                              >
                                <h5 className="text-secondary fw-bold">
                                  {this.props.t("Zip Code")}
                                </h5>
                              </Label>
                              <div className="col-md-10">
                                <Field
                                  className={
                                    "form-control fs-5" +
                                    (errors.zipCode && touched.zipCode
                                      ? " is-invalid"
                                      : "")
                                  }
                                  type="text"
                                  name="zipCode"
                                  placeholder="zipCode code"
                                />
                                <ErrorMessage
                                  name="zipCode"
                                  component="div"
                                  className="invalid-feedback"
                                />
                              </div>
                            </div>
                            <div className="mb-3 row">
                              <Label
                                htmlFor="mobileNo1"
                                className="col-md-2 col-form-label"
                              >
                                <h5 className="text-secondary fw-bold">{this.props.t('Mobile no.1')}</h5>
                              </Label>
                              <div className="col-md-10">
                                <Field
                                  className={
                                    "form-control fs-5" +
                                    (errors.mobileNo1 && touched.mobileNo1
                                      ? " is-invalid"
                                      : "")
                                  }
                                  type="number" onWheel={(e) => e.target.blur()}
                                  name="mobileNo1"
                                  placeholder="+91 (132)(564)(9872)"
                                />
                                <ErrorMessage
                                  name="mobileNo1"
                                  component="div"
                                  className="invalid-feedback"
                                />
                              </div>
                            </div>
                            <div className="mb-3 row">
                              <Label
                                htmlFor="mobileNo2"
                                className="col-md-2 col-form-label"
                              >
                                <h5 className="text-secondary fw-bold">{this.props.t('Mobile no.2')}</h5>
                              </Label>
                              <div className="col-md-10">
                                <Field
                                  className={
                                    "form-control fs-5" +
                                    (errors.mobileNo2 && touched.mobileNo2
                                      ? " is-invalid"
                                      : "")
                                  }
                                  type="number" onWheel={(e) => e.target.blur()}
                                  name="mobileNo2"
                                  placeholder="+91 (132)(564)(9872)"
                                />
                                <ErrorMessage
                                  name="mobileNo2"
                                  component="div"
                                  className="invalid-feedback"
                                />
                              </div>
                            </div>
                            <div className="mb-3 row">
                              <Label
                                htmlFor="email"
                                className="col-md-2 col-form-label"
                              >
                                <h5 className="text-secondary fw-bold">{this.props.t('Email ID')}</h5>
                              </Label>
                              <div className="col-md-10">
                                <Field
                                  className={
                                    "form-control fs-5" +
                                    (errors.email && touched.email
                                      ? " is-invalid"
                                      : "")
                                  }
                                  type="email"
                                  name="email"
                                  placeholder="Enter a valid Email ID"
                                />
                                <ErrorMessage
                                  name="email"
                                  component="div"
                                  className="invalid-feedback"
                                />
                              </div>
                            </div>
                            <div className="mb-3 row">
                              <Label
                                htmlFor="shortName"
                                className="col-md-2 col-form-label"
                              >
                                <h5 className="text-secondary fw-bold">
                                  {this.props.t("Short Name")}
                                </h5>
                              </Label>
                              <div className="col-md-10">
                                <Field
                                  className={
                                    "form-control fs-5" +
                                    (errors.shortName && touched.shortName
                                      ? " is-invalid"
                                      : "")
                                  }
                                  type="text"
                                  name="shortName"
                                  placeholder="P3Y"
                                />
                                <ErrorMessage
                                  name="shortName"
                                  component="div"
                                  className="invalid-feedback"
                                />
                              </div>
                            </div>
                            <div className="mb-3 row">
                              <Label
                                htmlFor="since"
                                className="col-md-2 col-form-label"
                              >
                                <h5 className="text-secondary fw-bold">
                                  {this.props.t("Since")}
                                </h5>
                              </Label>
                              <div className="col-md-10">
                                <Field
                                  className={
                                    "form-control fs-5" +
                                    (errors.since && touched.since
                                      ? " is-invalid"
                                      : "")
                                  }
                                  type="text"
                                  name="since"
                                  placeholder="2001"
                                />
                                <ErrorMessage
                                  name="since"
                                  component="div"
                                  className="invalid-feedback"
                                />
                              </div>
                            </div>
                            <div className="mb-3 row">
                              <Label
                                htmlFor="tagLine"
                                className="col-md-2 col-form-label"
                              >
                                <h5 className="text-secondary fw-bold">
                                  {this.props.t("Tagline")}
                                </h5>
                              </Label>
                              <div className="col-md-10">
                                <Field
                                  className={
                                    "form-control fs-5" +
                                    (errors.tagLine && touched.tagLine
                                      ? " is-invalid"
                                      : "")
                                  }
                                  type="text"
                                  name="tagLine"
                                  placeholder="#Tagline"
                                />
                                <ErrorMessage
                                  name="tagLine"
                                  component="div"
                                  className="invalid-feedback"
                                />
                              </div>
                            </div>
                            <div className="mb-3 row">
                              <Label
                                htmlFor="adminNotes"
                                className="col-md-2 col-form-label"
                              >
                                <h5 className="text-secondary fw-bold">{this.props.t('Admin Notes')}</h5>
                              </Label>
                              <div className="col-md-10">
                                <Field
                                  className={
                                    "form-control fs-5" +
                                    (errors.adminNotes && touched.adminNotes
                                      ? " is-invalid"
                                      : "")
                                  }
                                  type="text"
                                  name="adminNotes"
                                  as="textarea"
                                  rows="5"
                                />
                                <ErrorMessage
                                  name="adminNotes"
                                  component="div"
                                  className="invalid-feedback"
                                />
                              </div>
                            </div>

                            <div className="col-md-12 text-end">
                              <Button
                                color="primary"
                                className="fs-4 px-5"
                                type="submit"
                                onClick={() => this.handleSubmit(event, values)}
                              >
                                Submit
                              </Button>
                            </div>
                          </Row>
                        </Form>
                      )}
                    </Formik>
                  </CardBody>
                </Card>
              </Col>
            </Row>
          </Container>
        </div>
      </React.Fragment>
    );
  }
}

export default withTranslation()(OrganizationDetail);